module.exports = __webpack_public_path__ + "static/img/error.2a184d3e.png";